<article id="main">
	<header>
		<h1>Residential & Commercial Services</h1>
		<div class="push" />
	</header>
	<section class="wrapper alt style5">
		<section class="spotlight">
			<div class="content">
				<h2>Residential Can Cleaning</h2>
				<ul>
					<li>Curbside Service</li>
					<li>High temperature power wash</li>
					<li>Disinfecting & deodorizing</li>
				</ul>
			</div>
			<div class="image"><img src="images/truck-action.webp" alt="" /></div>
		</section>
		<section class="spotlight">
			<div class="image"><img src="images/dumpster.webp" alt="" /></div>
			<div class="content">
				<h2>Commercial power washing & dumpster cleaning</h2>
				<ul>
					<li>Dumpster & Dumpster Pad Cleaning</li>
					<li>
						Cleaning Exterior Concrete Surface like parking lots, sidewalks, drive-thrus &
						restaurant patios
					</li>
					<li>Cleaning Heavy Equipment, Fleet Vehicles, Farm Equipment, Trucks & Trailers</li>
					<li>Sanitizing & Disinfecting Shopping Carts, Playground Equipment, etc.</li>
				</ul>
			</div>
		</section>
	</section>
</article>

<style lang="scss">
	.image {
		width: 40%;
	}
</style>
